import { useAppSelector } from 'app/hooks';
import { ExistingSystemType } from 'data/types';
import { useMemo } from 'react';
import { getChooseSystemsEligibleDuctedSystems } from 'utils/existing-equipment';
import { buildDuctedRailSection } from './ducted-rail-sections';
import { DuctedRailSectionModel } from './ducted-rail-sections-types';

type DuctedRailSections = {
  eligibleSystems: ExistingSystemType[];
  sections: DuctedRailSectionModel[];
};

export default function useDuctedRailSections(): DuctedRailSections {
  const existingSystems = useAppSelector(
    (state) => state.structure.existingSystems
  );
  const recommendationSelectionsBySystem = useAppSelector(
    (state) => state.structure.recommendationSelectionsBySystem
  );
  const wantCompositionPicksBySystem = useAppSelector(
    (state) => state.structure.wantCompositionPicksBySystem
  );
  const compatibleResultsBySystem = useAppSelector(
    (state) => state.structure.compatibleResultsBySystem
  );
  const resultsBySystem = useAppSelector(
    (state) => state.ductedCompatibility.resultsBySystem
  );
  const representativesBySystem = useAppSelector(
    (state) => state.ductedCompatibility.representativesBySystem
  );
  const systemTypeSelections = useAppSelector(
    (state) => state.ui.ductedFilters.systemTypeSelections
  );
  const fuelSelections = useAppSelector(
    (state) => state.ui.ductedFilters.fuelSelections
  );
  const systemSort = useAppSelector((state) => state.ui.systemSort);
  const equipmentMatchingOnly = useAppSelector(
    (state) => state.ui.ductedFilters.equipmentMatchingOnly
  );

  // Virtual-tile haves (zero components, completed strip) render like any
  // all-replacing system: hasKept=false, one unlabeled alternatives section.
  const eligibleSystems = useMemo(
    () =>
      getChooseSystemsEligibleDuctedSystems(
        existingSystems,
        recommendationSelectionsBySystem,
        wantCompositionPicksBySystem
      ),
    [
      existingSystems,
      recommendationSelectionsBySystem,
      wantCompositionPicksBySystem
    ]
  );

  const sections = useMemo(
    () =>
      eligibleSystems.map((system) =>
        buildDuctedRailSection(system, {
          resultsBySystem,
          representativesBySystem,
          systemTypeSelections,
          fuelSelections,
          systemSort,
          equipmentMatchingOnly,
          compatibleResultsBySystem
        })
      ),
    [
      eligibleSystems,
      resultsBySystem,
      representativesBySystem,
      systemTypeSelections,
      fuelSelections,
      systemSort,
      equipmentMatchingOnly,
      compatibleResultsBySystem
    ]
  );

  return { eligibleSystems, sections };
}
